import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';
import { S_Checkbox } from '../../../../../design/inputs/checkbox/S_Checkbox';
import { S_ClampLines } from '../../../../../design/misc/S_ClampLines';
import { handleChange } from '../../../../helpers/formHelpers';
import { IAnswerProps } from '../../question.model';

export const AnswerWithCheckBox = observer(
  ({ disabled: readonly, name, answer, onAnswered: onAnswerSelect }: IAnswerProps): ReactElement => (
    <div title={answer.text}>
      <S_Checkbox
        slotProps={{
          input: { tabIndex: 1 },
        }}
        id={answer.id}
        name={name}
        value={answer.id}
        checked={answer.selected}
        onChange={handleChange(onAnswerSelect)}
        disabled={readonly}
        label={
          <S_ClampLines
            id={`answer-${answer.id}`}
            text={answer.text}
            lines={3}
          />
        }
      />
    </div>
  )
);
